import WidgetSectionTitle from "widgets/WidgetSectionTitle";
import MessageTemplateForm from "./MessageTemplateForm";
import useMessageTemplates from "hooks/message-templates/useMessageTemplates";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";

export default function CreateMessageTemplate() {
  const navigate = useNavigate();
  const { createTemplate } = useMessageTemplates();

  const handleSubmit = async (values) => {
    try {
      const newTemplate = await createTemplate(values);
      navigate(`/account/message-templates`);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3 gap-3">
        <WidgetSectionTitle
          icon="envelope-open-text"
          title="Create Message Template"
          subtitle="Define a new email or SMS template"
          className="mb-3 mt-3 flex-1"
        />

        <Button
          variant="info"
          size="sm"
          className="text-sm"
          onClick={() => navigate(`/account/message-templates`)}
        >
          Go Back
        </Button>
      </div>

      <MessageTemplateForm
        onSubmit={handleSubmit}
        submitLabel="Create Template"
      />
    </>
  );
}
